import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCustomerDetail, getCustomers, getCustomersKasir } from "../service/customer.service";
import { createCustomer, deleteCustomer, updateCustomer } from "../service/customer.mutation.service";
import type { CustomerFormData } from "@/schemas/customer.schema";


export const useCustomers = (email: string) => {
    return useQuery({
        queryKey: ["customers", email],
        queryFn: () => getCustomers(email),
        enabled: !!email,
    });
};

export const useCustomersKasir = (email: string, name?: string | null) => {
    return useQuery({
        queryKey: ["customers", email, name],
        queryFn: () => getCustomersKasir(email, name),
        enabled: !!email,
    });
};



export const useCustomersDetail = ({ email, id }: { email: string, id: number | undefined | null }) => {
    return useQuery({
        queryKey: ["customers", email, id],
        queryFn: () => getCustomerDetail({ email, id }),
        enabled: !!email && !!id,
    });
};


// Hook untuk Create Customer
export const useCreateCustomer = (email: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CustomerFormData) => createCustomer(email, data),
        onSuccess: () => {
            // Invalidate dan refetch customers list
            queryClient.invalidateQueries({ queryKey: ["customers", email] });
        },
    });
};

// Hook untuk Update Customer
export const useUpdateCustomer = (email: string, custId: number) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CustomerFormData) => updateCustomer(email, custId, data),
        onSuccess: () => {
            // Invalidate customers list dan detail
            queryClient.invalidateQueries({ queryKey: ["customers", email] });
            queryClient.invalidateQueries({ queryKey: ["customers", email, custId] });
        },
    });

};

export const useDeleteCustomer = (email: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (custId: number) => deleteCustomer(email, custId),
        onSuccess: () => {
            // Invalidate customers list setelah delete
            queryClient.invalidateQueries({ queryKey: ["customers", email] });
        },
    });
};